import { IHealthCheckData } from '@/interfaces/IHealthCheckData';
import ApiHelper from './apiHelper';

export default class HealthCheckApi {
    static async getHealthCheckInformation (): Promise<Array<IHealthCheckData>> {
        return (await ApiHelper.post('GetHealthCheckInformation', {})).data as Promise<Array<IHealthCheckData>>;
    }
}